import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class BidsService {
  constructor(private http: HttpClient) {}
  // ton apis
  getLoadBids(id) {
    return this.http.get(
      environment.apiUrl + `admin/load/bids/all?loadId=${id}`
    );
  }
  getVacantVehicleBids(id) {
    return this.http.get(
      environment.apiUrl +
        `admin/vacant/vehicles/bids/all?vacantVehicleId=${id}`
    );
  }
}
